import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { PlanSelection } from "src/app/models/plan-selection/plan-selection";
import { VinValidate } from "src/app/models/vin-validate/vin-validate";
import { environment } from "src/environments/environment";

const httpOptions = {
	headers: new HttpHeaders({
        'Content-Type': 'application/json'
	})
};

@Injectable({
  providedIn: 'root'
})
export class PlanSelecionService {

    private apiUrl = environment.apiUrl;
    private planSelectionList: PlanSelection[] = [];

    constructor(private httpClient: HttpClient, private messageService: MessageService) {
    }

    getPlanSelection(validatedVins: VinValidate[]): Observable<PlanSelection[]> {      
      return this.httpClient.post(`${this.apiUrl}/api/vins/motorAndModelYearGrouping/`, validatedVins, httpOptions)
        .pipe(
          map((response: PlanSelection[]) => {
            return response;
          })
        );
    }

    setAllPlanSelectionList(planSelections: PlanSelection[]) {
      this.planSelectionList = planSelections;
    }

    getAllPlanSelectionList(): PlanSelection[] {
      return this.planSelectionList;
    }
}
